import axios from '@/http/axios/index.js'


export default {
    getExpenses(payload) {
        return axios.get('pre_expenses/list', { params: payload }).then(res => res.data)
    },
    getExpense(payload) {
        return axios.get('pre_expenses/show', { params: payload }).then(res => res.data)
    },
    approveExpense(payload) {
        return axios.post('pre_expenses/approved', payload).then(res => res.data)
    },
    deleteExpense(payload) {
        return axios.delete('pre_expenses/delete', { params: payload }).then(res => res.data)
    },
    getFiles(payload) {
        return axios.get('pre_expenses/files', { params: payload }).then(res => res.data)
    },
    updateExpense(payload) {
        return axios.post('pre_expenses/update-expense', payload).then(res => res.data)
    }
}